import SaleProductFormPage from "./SaleProductFormPage";

export default function CreateSaleProductPage() {
  return <SaleProductFormPage />;
}
